module.exports = __webpack_public_path__ + "img/aerial-view-image.1f354281.jpg";